import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { TextField } from 'mw-style-react';
import '../Panel.scss';

/**
 * Компонент Edit
 */
class Edit extends Component {
  shouldComponentUpdate(nextProps) {
    const { value } = this.props;
    return nextProps.value !== value;
  }

  render() {
    const { id, regexp, title, errors, value, onChange, handleIdChange } =
      this.props;
    const error = errors[id];
    return (
      <div styleName="panel__el">
        <TextField
          id={id}
          bordered={true}
          label={title}
          value={value}
          error={!!error}
          regexp={regexp}
          helperText={error || ''}
          onChange={id === 'id' ? handleIdChange : onChange}
        />
      </div>
    );
  }
}

Edit.defaultProps = {
  errors: {},
  value: '',
};

Edit.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
  errors: PropTypes.object,
  regexp: PropTypes.string,
  onChange: PropTypes.func,
  handleIdChange: PropTypes.func,
};

export default Edit;
